import { Box, Typography } from '@mui/material';
import { numberFormatterDollar } from '@src/app/utils/GenericUtils';
import { FC } from 'react';

export interface PortfolioValueProps {
  totalValue?: number;
}

const PortfolioValue: FC<PortfolioValueProps> = ({ totalValue }: PortfolioValueProps): JSX.Element => {
  return (
    <Box component="div" display="flex" flexDirection="column" gap={1} flex={1}>
      <Typography sx={{ color: '#979797' }} fontWeight={700} variant="subtitle2" textTransform="uppercase">
        Total Value
      </Typography>
      <Typography fontWeight={700} fontSize={36}>
        {numberFormatterDollar(totalValue ?? 0, 2)}
      </Typography>
    </Box>
  );
};

export default PortfolioValue;
